import { computed } from 'vue'
import { useGlobalStore } from '@/stores'

export default () => {
  return {
    isInstantSearch: computed(() => {
      return !!useGlobalStore().instantSearchProps
    })
  }
}
